import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {catholicHouseholdSchema} from "../../../apis/catholicHousehold";

const CatholicHouseholdEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={catholicHouseholdSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const CatholicHouseholdEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[catholicHouseholdSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default CatholicHouseholdEntity
